// 첫 화면 메뉴 = 관리자 빠른 지원 카테고리(운영 설정 순서) + 고정 「공지사항」.
// 카테고리 이름으로 접수 흐름을 고른다 — 맞는 흐름이 없으면 가맹점 확인 → 내용·사진 → 접수(other).
// 카테고리 이름 키워드 → 흐름(기획안 §14-6)
const KEYWORDS = { paper: ["용지"], sales: ["매출"], menu: ["메뉴"], printer: ["프린터"], pay: ["결제", "단말기"] };
export const flowOf = (name = "") => Object.keys(KEYWORDS).find((k) => KEYWORDS[k].some((w) => name.includes(w))) || "other";

export const NOTICE_KEY = "notice";
export function menusFrom(categories = [], lang = "ko") {
    const zh = lang === "zh";
    return [
        ...categories.map((c) => ({
            key: `c${c.id}`, kind: "intake", flow: flowOf(c.name), cat: c,
            title: (zh && c.name_zh) || c.name || "", desc: (zh && c.description_zh) || c.description || "",
        })),
        { key: NOTICE_KEY, kind: "notice" },
    ];
}

// 재문의: 흐름에 맞는 카테고리(구분을 붙이려고)
export function matchCategory(key, categories = []) {
    const words = KEYWORDS[key];
    if (!words) return null;
    return categories.find((c) => words.some((w) => (c.name || "").includes(w))) || null;
}
const LEGACY = { paper: "paper_request", sales: "sales_report", menu: "kiosk_menu_update" };
export const inquiryTypeOf = (key) => LEGACY[key] || "other";

// 재문의: 이전 문의의 세부 이름으로 메뉴를 찾는다
export function menuForSubcategory(label) {
    if (!label) return null;
    return ["paper", "sales", "menu", "printer", "pay"].find((k) => KEYWORDS[k].some((w) => label.includes(w))) || null;
}

// 받는 곳(계약 §14-2, 전체 일치): 이메일(254자 이하) 또는 팩스
const EMAIL = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;
const FAX = /^(?:0\d{1,3}-?\d{3,4}-?\d{4}|1[5-9]\d{2}-?\d{4})$/;
export function isReceiveAddress(v) {
    const s = (v || "").trim();
    return (s.length <= 254 && EMAIL.test(s)) || FAX.test(s);
}
